import _ from 'lodash'
import numeral from 'numeral'

if (numeral.locales['de'] === undefined) {
  numeral.register('locale', 'de', {
    delimiters: {
      thousands: '.',
      decimal: ','
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal: (number: number) => {
      return number === 1 ? 'ste' : 'te'
    },
    currency: {
      symbol: '€'
    }
  })
}

// switch between locales
numeral.locale('de')

const formatNumber = (value: number | string, decimals: number = 2) => {
  if (!value && value !== 0 && value !== 0.0) {
    return ''
  }
  const values = typeof value === 'string' ? _.split(value, '.') : [value]
  const decimal = values[1] as string
  value = values[0]

  if (decimals) {
    value += ',' + _.truncate(_.pad(decimal, decimals, '0'), {length: decimals})
  }

  return value
}

export const currency = (value: number | string, decimals = 2) => {
  value = formatNumber(value, decimals)

  return numeral(value).format('0,0 $')
}

export const number = (value: number | string, decimals: number = 2, symbol: string | null = null) => {
  value = formatNumber(value, decimals)
  return numeral(value).format('0,0') + ' ' + (symbol || '')
}
